import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { IS_SAAS } from "@coso/utility";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { ActionType, ILogHistoryDto } from "../models/auto-generated";
import { parseErrorBlob } from "../utils/parse-error-blob";

@Injectable({
  providedIn: "root"
})
export class HistoryLogsService {
  private getBaseRoute(instanceId: string): string {
    return `/api/configurations/${instanceId}/history-logs`;
  }
  constructor(@Inject(IS_SAAS) private isSaaS: boolean, private http: HttpClient) {}

  get(instanceId: string, limit: number, offset: number, source: string, types: ActionType[], startDate: string, endDate: string, searchTerm: string, lastLogTimeStamp : string, firstLogTimeStamp : string, originalOffset: number): Observable<ILogHistoryDto> {
    const baseRoute = this.getBaseRoute(instanceId);
    let params = this.prepareLogHttpParams(limit, offset, source, types, searchTerm, startDate, endDate, lastLogTimeStamp, firstLogTimeStamp, originalOffset);
    return this.http.get<ILogHistoryDto>(baseRoute, { params: params });
  }

  exportAsZip(instanceId: string): Observable<Blob> {
    const baseRoute = this.getBaseRoute(instanceId);
    return this.isSaaS ? throwError("Unsupported operation!") : this.http.post(`${baseRoute}/export`, {}, { responseType: "blob" }).pipe(catchError(parseErrorBlob));
  }

  exportAsExcel(instanceId: string, limit: number, offset: number, source: string, types: ActionType[], startDate: string, endDate: string, searchTerm: string): Observable<Blob> {
    const baseRoute = this.getBaseRoute(instanceId);
    let params = this.prepareLogHttpParams(limit, offset, source, types, searchTerm, startDate, endDate, undefined, undefined, 0);    
    return this.http.post(`${baseRoute}/export-filtered`, {}, { params: params, responseType: "blob" }).pipe(catchError(parseErrorBlob));
  }

  clear(instanceId: string, days?: number): Observable<any> {
    let params = new HttpParams();
    if (days) {
      params = params.append("days", days.toString());
    }
    const baseRoute = this.getBaseRoute(instanceId);
    return this.isSaaS ? throwError("Unsupported operation!") : this.http.delete(`${baseRoute}/clear`, { params: params });
  }

  private prepareLogHttpParams(limit: number, offset: number, source: string, types: ActionType[], searchTerm: string, startDate: string, endDate: string,
     lastLogTimeStamp : string, firstLogTimeStamp : string, originalOffset: number) {
    let params = new HttpParams();
    params = params.append("limit", limit.toString());
    params = params.append("offset", offset.toString());
    params = params.append("source", source);
    types.forEach((type) => (params = params.append("logType", type.toString())));
    if (!!searchTerm) {
      params = params.append("searchTerm", searchTerm);
    }
    if (!!startDate) {
      params = params.append("startDate", startDate);
    }
    if (!!endDate) {
      params = params.append("endDate", endDate);
    }
    if (!!originalOffset) {
      params = params.append("originalOffset", originalOffset.toString());
    }
    if (!!lastLogTimeStamp) {
      params = params.append("lastLogTimeStamp", lastLogTimeStamp);
    }
    if (!!firstLogTimeStamp) {
      params = params.append("firstLogTimeStamp", firstLogTimeStamp);
    }
    return params;
  }
}
